<ng-template [appTopbarTemplate]>
  <div class="title h4">{{ texts.welcome | localize }}</div>

  <div class="actions">
    <button class="btn btn-dark btn-round btn-sm" (click)="createModal.start()">
      <i class="fa-sharp fa-solid fa-plus me-2"></i> {{ texts.newJob | localize }}
    </button>
  </div>
</ng-template>


<div class="content" [@fadeIn]="state">

  <div class="container-xl">

    @if (demo.isActive) {
    <div class="row mb-4">

      <div class="col-12">

        <a class="card card-clickable" routerLink="/pool">
          <!-- <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="card-title">
                  {{ texts.pool.title | localize }}
                </h6>
              </div>
              <div class="col-auto">
                <a class="btn btn-sm btn-secondary">{{ texts.pool.detailLink | localize }} <i class="fa-sharp fa-solid fa-arrow-right ms-2"></i></a>
              </div>
            </div>
          </div> -->

          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <h3 class="mb-1">{{ poolKpis.size | number }}</h3>
                <span class="text-muted small">{{ texts.pool.size | localize }}</span>
              </div>
              <div class="col-4">
                <h3 class="mb-1">{{ poolKpis.switchSignals | number }}</h3>
                <span class="text-muted small">{{ texts.pool.switchSignals | localize }}</span>
              </div>
              <div class="col-4">
                <h3 class="mb-1">{{ poolKpis.engagements | number }}</h3>
                <span class="text-muted small">{{ texts.pool.engagements | localize }}</span>
              </div>
              
            </div>

            <div class="row mt-4">

              <div class="col-6 d-flex">
                <div class="list-group flex-grow-1">
                  <div class="list-group-item d-flex flex-column flex-grow-1">
                    <p class="small fw-bold mb-3">{{ texts.pool.growth | localize }}</p>
                    <div class="pool-chart">
                      <canvas #poolChart class="chart-canvas"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="list-group list-group fw-normal">
                  <div class="list-group-item">
                    <div class="small fw-bold mb-0">Pool-Ereignisse</div>
                  </div>
                  <div class="list-group-item" *ngFor="let a of poolActivities">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <sc-avatar [user]="a.Candidate" size="sm"></sc-avatar>
                      </div>
                      <div class="col col-shrink ms-n2">
                        <p class="mb-0">
                          <span class="fw-bold">{{ a.Candidate.FirstName }} {{ a.Candidate.LastName }}</span>
                        </p>
                        <div class="small text-muted oneline">
                          <i class="fa-sharp fa-solid fa-bolt me-1"></i>{{ a.SignalLabel }} · {{ a.Timestamp | humanizedDate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </a>
      </div>

    </div>
    }

    <div class="row mb-4">

      <div class="col-12">

        <div class="card">
          <div class="card-header">
            <h6 class="card-title">
              {{ texts.preparedJobs.title | localize }}
            </h6>
          </div>

          <div class="card-body" *ngIf="!preparedProjects?.length">
            {{ texts.preparedJobs.empty | localize }}
          </div>

          <div class="card-body card-body-list" *ngIf="preparedProjects?.length">
            <app-list-projects [projects]="preparedProjects" [language]="loc.language"></app-list-projects>
          </div>

          <div class="card-footer" *ngIf="preparedMoreCount > 0">
            <div class="row d-flex justify-content-center">
              <div class="col-auto">
                <a class="btn btn-secondary btn-round btn-sm" [routerLink]="['/projects']"
                  [queryParams]="{ status: 'AwaitingOrder' }">{{ preparedMoreCount }} {{ texts.more | localize }}</a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-12">

        <div class="card">
          <div class="card-header">
            <h6 class="card-title">
              {{ texts.runningJobs.title | localize }}
            </h6>
          </div>

          <div class="card-body" *ngIf="!runningProjects?.length">
            {{ texts.runningJobs.empty | localize }}
          </div>

          <div class="card-body card-body-list" *ngIf="runningProjects?.length">
            <app-list-projects [projects]="runningProjects" [language]="loc.language"></app-list-projects>
          </div>

          <div class="card-footer" *ngIf="runningMoreCount > 0">
            <div class="row d-flex justify-content-center">
              <div class="col-auto">
                <a class="btn btn-secondary btn-round btn-sm" [routerLink]="['/projects']"
                  [queryParams]="{ status: 'Sourcing' }">{{ runningMoreCount }} {{ texts.more | localize }}</a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

  <!-- previous dashboard content, kept for reference. @if (false) instead of an
       html comment because the markup below contains comments of its own. -->
  @if (false) {
  <!-- <div class="container intro-container">

    <div class="row align-items-center mb-3 mb-md-0" *ngIf="intro">

      <div class="col-7 col-md pe-lg-5">

        <h1 class="h2 mb-md-4 heading-serif">
          {{ intro.Salutation }} <br> {{ intro.FirstName }} <span class="d-none d-md-inline-block">{{ intro.LastName }}</span>
        </h1>

        <app-notification class="d-none d-md-block" *ngIf="notifications.projects?.length" (click)="showNotifications()" [badge]="notifications.items?.length" ctaLabel="Aufgaben ansehen">
          Ihr Einsatz ist gefragt!
        </app-notification>

      </div>

      <div class="col-md-auto col-4">
        <img class="img-fluid" src="assets/illus/skillconomy-bot-presenting.svg">
      </div>

    </div>

    <div class="row">
      <div class="d-md-none col">
        <app-notification *ngIf="notifications.projects?.length" (click)="showNotifications()" [badge]="notifications.projects?.length" ctaLabel="Aufgaben ansehen">
          Ihr Einsatz ist gefragt!
        </app-notification>
      </div>
    </div>
  </div> -->

  <!-- <div class="container mb-6">
    <app-dashboard-announcement></app-dashboard-announcement>
  </div> -->



  <div class="container mb-6" *ngIf="reporting?.IsEnabled">

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="card-title">
                  {{ texts.reporting.title | localize }}
                </h6>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <h2 class="mb-1" *ngIf="reporting?.CostPerApplication != 'NaN'">
                  {{ reporting?.CostPerApplication | number : '0.0-0' }}€
                </h2>
                <h2 class="mb-1" *ngIf="reporting?.CostPerApplication == 'NaN'">
                  - €
                </h2>
                <span>Cost per Application</span>
              </div>

              <div class="col-4">
                <h2 class="mb-1" *ngIf="reporting?.WorkloadPerApplication != 'NaN'">
                  {{ reporting?.WorkloadPerApplication | number : '0.1-1' }} Min.
                </h2>
                <h2 class="mb-1" *ngIf="reporting?.WorkloadPerApplication == 'NaN'">
                  - Min.
                </h2>
                <span>Workload per Application</span>
              </div>

              <div class="col-4">
                <h2 class="mb-1" *ngIf="reporting?.ReturnOnInvestment != 'NaN'">
                  {{ reporting?.ReturnOnInvestment | number : '0.0-0' }}%
                </h2>
                <h2 class="mb-1" *ngIf="reporting?.ReturnOnInvestment == 'NaN'">
                  - %
                </h2>
                <span>Return on Investment</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col">
              </div>
              <div class="col-auto">
                <a routerLink="/reporting" class="link-arrow right">{{ texts.reporting.detailLink | localize }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container project-container">

    <div class="row">

      <div class="col-12">

        <div class="card">

          <div class="card-header">
            <h6 class="card-title">
              <i class="fa-sharp fa-solid fa-stars me-2"></i> Vorschläge
            </h6>
          </div>

          <div class="card-body card-body-list">
            <div class="list-group fw-normal">

              <div class="list-group-item" *ngFor="let item of suggestions">

                <div class="row">

                  <div class="col-auto">
                    <sc-avatar [user]="item.Author" size="sm"></sc-avatar>
                  </div>

                  <div class="col col-shrink ms-n2">

                    <!-- <h6 class="mb-0 d-inline-block">{{ item.Author.FirstName }} {{ item.Author.LastName }}</h6>
                    <time class="d-inline-block ms-2 mb-0 text-muted smaller">{{ item.Timestamp }}</time> -->

                    <p class="mb-0">{{ item.Text }}</p>

                    <p class="suggested-message small mt-2 mb-0" *ngIf="item.Message">{{ item.Message }}</p>

                    <div class="row align-items-center mt-3" *ngIf="!item.State">
                      <div class="col-auto">
                        <button class="btn btn-sm btn-dark" (click)="confirmAction(item)">
                          {{ item.ConfirmLabel }}
                          <i class="fa-sharp fa-solid fa-arrow-right ms-2"></i>
                        </button>
                      </div>
                      <div class="col-auto ps-0">
                        <button class="btn btn-sm btn-secondary" (click)="declineAction(item)">
                          {{ item.DeclineLabel }}
                        </button>
                      </div>
                    </div>

                    <p class="small text-muted mb-0 mt-3" *ngIf="item.State == 'confirmed'">
                      <i class="fa-sharp fa-solid fa-check me-2"></i> {{ item.ConfirmedText }}
                    </p>

                    <p class="small text-muted mb-0 mt-3" *ngIf="item.State == 'declined'">
                      <i class="fa-sharp fa-solid fa-xmark me-2"></i> Vorschlag verworfen.
                    </p>

                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

  <div class="container project-container">

    <div class="row">

      <div class="col-12">

        <div class="card">

          <div class="card-header">
            <h6 class="card-title">
              Aktivitäten
            </h6>
          </div>

          <div class="card-body card-body-list">
            <div class="list-group fw-normal">

              <div class="list-group-item" *ngFor="let item of activities">

                <div class="row">

                  <div class="col-auto">
                    <sc-avatar [user]="item.Author" size="sm"></sc-avatar>
                  </div>

                  <div class="col col-shrink ms-n2">

                    <h6 class="mb-0 d-inline-block">{{ item.Author.FirstName }} {{ item.Author.LastName }}</h6>
                    <time class="d-inline-block ms-2 mb-0 text-muted smaller">{{ item.Timestamp }}</time>

                    <p class="mb-0">{{ item.Text }}</p>

                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

  <div class="container project-container mb-6">

    <div class="row">

      <div class="col-12">

        <div class="card">
          <div class="card-header">
            <h6 class="card-title">
              {{ texts.preparedJobs.title | localize }}
            </h6>
          </div>

          <div class="card-body" *ngIf="!newProjects?.length">
            {{ texts.preparedJobs.empty | localize }}
          </div>

          <div class="card-body card-body-list" *ngIf="newProjects?.length">
            <app-list-projects [projects]="newProjects" [language]="loc.language"></app-list-projects>
          </div>

          <div class="card-footer">
            <div class="row d-flex justify-content-center">
              <div class="col-auto">
                <a class="btn btn-secondary btn-round btn-sm" [routerLink]="['/projects']"
                  [queryParams]="{ status: 'AwaitingOrder' }">{{ texts.viewAll | localize }}</a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

  <div class="container project-container">

    <div class="row">

      <div class="col-12">

        <div class="card">

          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="card-title">
                  {{ texts.runningJobs.title | localize }}
                </h6>
              </div>
            </div>

          </div>
          <div class="card-body" *ngIf="!projects?.length">
            {{ texts.runningJobs.empty | localize }}
          </div>
          <div class="card-body card-body-list" *ngIf="projects?.length">
            <app-list-projects [projects]="projects" [language]="loc.language"></app-list-projects>
          </div>

          <div class="card-footer">
            <div class="row d-flex justify-content-center">
              <div class="col-auto">
                <a class="btn btn-secondary btn-round btn-sm" [routerLink]="['/projects']"
                  [queryParams]="{ status: 'Sourcing' }">{{ texts.viewAll | localize }}</a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
  }
</div>

<app-modal-create-project #createModal [language]="loc.language"></app-modal-create-project>